<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-12">
    <cf-order-item
      v-for="(item, idx) in items"
      :key="idx"
      :item="item"
      :order="order"
      :hide-quantity="hideQuantity"
      :hide-prices="hidePrices"
      :is-favoriting-disabled="disableFavoriting"
      :is-read-only="isReadOnly"
      :is-your-order-item="isYourOrderItem"
      :is-receipt-view="isReceiptView"
      :is-item-rating-enabled="isItemRatingEnabled"
      class="cf-list-item-padding-bottom cf-list-item-border-bottom"
    />

    <p
      v-if="order.includeUtensils"
      class="cf-subtitle cf-subtitle--2"
    >
      <span>*</span>

      {{ content.ReceiptStandard.metadata.utensilsIncludedMessage }}
    </p>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfOrderItem from '@/view/components/globals/cf-order-item/index.vue';


  export default {
    name: 'CfOrderItems',

    components: {
      CfOrderItem
    },

    props: {
      disableFavoriting: {
        type: Boolean,
        default: false
      },

      hidePrices: {
        type: Boolean,
        default: false
      },

      hideQuantity: {
        type: Boolean,
        default: false
      },

      order: {
        type: Object,
        required: true
      },

      orderItems: {
        type: Array,
        default: null
      },

      isReadOnly: {
        type: Boolean,
        default: false
      },

      isYourOrderItem: {
        type: Boolean,
        default: true
      },

      isReceiptView: {
        type: Boolean,
        default: false
      },

      isItemRatingEnabled: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        ratedOrderItems: {}
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('content', ['content']),

      items() {
        if (this.orderItems) {
          return this.orderItems;
        }

        return this.order.orderItems;
      }
    }
  };
</script>
